export { default as PractitionerManager } from './PractitionerManager';
export { default as PractitionerDialog } from './PractitionerDialog';
export { default as DeleteConfirmationDialog } from './DeleteConfirmationDialog';
export * from './practitionerService';